import React, { Component } from 'react';
import { View, Platform, Dimensions, Linking, Text } from 'react-native';
import { withRouter, Switch } from 'react-router-dom';
import { ModalContainer } from 'react-router-modal';
import IdleTimer from 'react-idle-timer';
import styles from './assets/styles/style';
import { BroadcastChannel } from 'broadcast-channel';
import {
  getMeasure,
  browserSupport,
  injectUrlPaths,
  linearColors,
  fetchUrl,
  checkHardwareDevice,
  getResponsiveStyle
} from './utils/appUtils';
import { APP } from './constants/textConstants';
import { AppProvider } from './AppContext';
import CacheBuster from './utils/CacheBuster';
import LinearGradient from './components/LinearGradient';
import CustomBootbox from './components/CustomBootbox.js';
import AvailableTimeError from './components/AvailableTimeError';
import WebRoutesGenerator from './NativeWebRouteWrapper';
import dayjs from 'dayjs';
import {
  ALL_CONSTANTS,
  SESSION_ALREADY_OPEN
} from './constants/displayConstants';
import CommonRouteMap from './ExportProducts/CommonRoutings';
import NLI_CONSTANTS from './Products/nli/data/urlPathConstants';
import CommonRouteMapImobileRouting from '@src/Products/nli/Imobile/routings.js'
import DormanyRemovalRouteMap from '@src/Products/DormancyRemoval/routes/dormancyRouting.js';
import {Helmet} from "react-helmet";
// ! Jquery must be loaded before bootstrap 
// ! bundle.js must be evaluated after bootstrap is ready or it will cause modals to not work  
// ! handled in index.html by moving bootstrap imports to head
// import 'jquery/dist/jquery.min.js';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.min.js'


const routeMap = {
  ...CommonRouteMapImobileRouting,
  ...DormanyRemovalRouteMap,
  ...CommonRouteMap
};

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  // dev code
} else {
  // production code
  window.onload = function () {
    document.addEventListener(
      'contextmenu',
      function (e) {
        e.preventDefault();
      },
      false
    );
    document.addEventListener(
      'keydown',
      function (e) {
        // document.onkeydown = function(e) {
        // "I" key
        if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
          disabledEvent(e);
        }
        // "J" key
        if (e.ctrlKey && e.shiftKey && e.keyCode == 74) {
          disabledEvent(e);
        }
        // "S" key + macOS
        if (
          e.keyCode == 83 &&
          (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)
        ) {
          disabledEvent(e);
        }
        // "U" key
        if (e.ctrlKey && e.keyCode == 85) {
          disabledEvent(e);
        }
        // "F12" key
        if (e.keyCode == 123) {
          disabledEvent(e);
        }
      },
      false
    );
    function disabledEvent(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      } else if (window.event) {
        window.event.cancelBubble = true;
      }
      e.preventDefault();
      return false;
    }
  };
  document.addEventListener('contextmenu', event => event.preventDefault());
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: '#F36414',
      openmodel: false,
      bootboxtext: '',
      modalopenhide: false,
      measure: getMeasure(this.getWidth()),
      workingtime: true,
      userIdle: false,
      maintainanceText: APP.MAINTAINANCE_TIME,
      linearColors: linearColors(),
      isDuplicate: false,
    };
    this.handleWindowPerformanceEvents();
    this.myContext = {
      vkycShowNewTab: true,
      showSavingsLoan: true,
      isSupported: false,
      clearStorage: val => this.clearStorage(val),
      setContext: val => this.setState(val),
      setTimer: val => this.setTimeout(val)
    };

    // Store the previous pathname and search strings
    this.currentPathname = null;
    this.currentSearch = null;

    this.workingTime = dayjs(new Date()).format('HH');
  }




  async isSupportedForVKYC() {
    let bSupport = false;
    bSupport = await checkHardwareDevice();
    bSupport = bSupport.isSupported;
    return bSupport;
  }

  changeBackground = color => {
    this.setState({ backgroundColor: color });
  };

  handleLayout = ({ nativeEvent }) => {
    const { width } = nativeEvent.layout;
    const measure = getMeasure(width);
    this.setState(() => ({ measure }));
  };

  getWidth = () => {
    const { width } = Dimensions.get('window');
    return width;
  };
  handleWindowPerformanceEvents = async () => {
    let ExternalFlag;
    if (Platform.OS === 'web') {
      ExternalFlag = sessionStorage.getItem('ExternalFlag');
    } else {
      ExternalFlag = await AsyncStorage.getItem('ExternalFlag');
    }
    var parts = window.location.pathname.split('/');
    var path = parts[parts.length - 1];

    if (window.performance) {
      if (
        path == "verify" ||
        path == "mobileno" ||
        path == "panno" ||
        path == "dob" ||
        path == "otp" ||
        path == "overdue" ||
        path == "vehicleDetails" ||
        path == "vehicleValuation" ||
        path == "carDetails" ||
        path == "cardekholeaddetails" ||
        path == "cibilTerms" ||
        path == "cibilData" ||
        path == "updated" ||
        path == "update" ||
        path == 'preview' ||
        path == 'tablescreen' ||
        path == 'error' ||
        path == 'payAmount' ||
        path == 'termsConditions' ||
        path == 'Verification' ||
        path == 'confirmManager' ||
        path == 'CancelautodebitTable' ||
        path == 'dualAuth'
      ) {
        if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'development' || process.env.NODE_ENV !== 'localhost') {
          if (
            performance.navigation.type === 0 &&
            !(
              window.location.pathname !== '404Page'
            ) &&
            !window.location.pathname !== '404Page'
          ) {
            await localStorage.clear();
          } else if (!window.location.pathname !== '404Page') {
            await localStorage.clear();
            const pathName = window.location.pathname;
            const domainName = window.location.origin;
            const path = [
              ALL_CONSTANTS.PROFILE_PATH,
              ALL_CONSTANTS.ACCOUNT_PATH,
              ALL_CONSTANTS.CREDIT_CARD_PATH,
              ALL_CONSTANTS.LOAN_PATH,
              ALL_CONSTANTS.DEPOSITS_PATH,
              ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH,
              ALL_CONSTANTS.FOREX_PATH,
              ALL_CONSTANTS.DUE_PATH,
              ALL_CONSTANTS.ATMDEBIT_PATH,
              ALL_CONSTANTS.OTHERURL_PATH
            ];

            let updatedPath = pathName.substr(0, pathName.lastIndexOf('/'));
            let sourceType =  sessionStorage.getItem('sourceType'); 
            let isStandAloneURL = sessionStorage.getItem('isStandAloneURL');
            if( isStandAloneURL ||sourceType == "CSP-IMOBILE"){
               return
            }
            if (path.includes(updatedPath)) {
              if (ExternalFlag != 'false') {
              } else {
                window.location.href = `${domainName}${updatedPath}`;
              }
              return;
            } else {
              if (ExternalFlag != 'false') {
              } else {
              window.location.href = `${window.location.origin}/servicing/index.html`;
              }

            }
            //window.location.href = `${window.location.origin}`+serviceName;
          }
        }
      }
      // }
    }
  };

  removeObserver = () => {
    console.log(
      "Removing mutation observer"
    );
    if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
    }
  }

 
clearCacheData = () => {
  caches.keys().then((names) => {
      names.forEach((name) => {
          caches.delete(name);
      });
  });
  console.log("Complete Cache Cleared");

};
  
  async componentDidMount() {
    this.clearCacheData()
   
 // * check for duplicate tab
    const bc = new BroadcastChannel("CSR-Project");
    bc.onmessage = (event) => {
      if (event === "newTab") {
        bc.postMessage(`duplicateTab`);
        this.setState({ isDuplicate: false })
      }
      if (event === `duplicateTab`) {
        const pathName = window.location.pathname;
        // * set isDuplicate false for bitly links
        if(["V-", "C-"].includes(window.location.search.substring(1,3))){
          this.setState({ isDuplicate: false })
        }
        // * allow duplicate tab for rekyc pdf links
        else if (pathName.includes(ALL_CONSTANTS.REKYC_FATCA_PDF_URL)) {
          this.setState({ isDuplicate: false })
        }
        else {
          this.setState({ isDuplicate: true })
        }
        bc.close()
      }
    };

    bc.postMessage('newTab');

    this.myContext = {
      ...this.myContext,
      isSupported: await this.isSupportedForVKYC()
    };
    const windowValues = window.location;
    this.navigateOptions();
    if (
      windowValues.pathname.includes('product') &&
      windowValues.search !== ''
    ) {
      fetchUrl(windowValues, this.props);
    }
    if (this.workingTime >= 6 && this.workingTime < 23) {
      this.setState({
        workingtime: true
      });
    } else {
      this.setState({
        workingtime:
          windowValues.hostname !== 'localhost' &&
            windowValues.hostname !== 'reacticicidev.niveussolutions.com'
            ? true
            : true
      });
    }

    if (
      window.location.hostname !== 'localhost' &&
      this.props.location.state &&
      this.props.location.state.idle
    ) {
      // this.setState({
      //   userIdle: true,
      //   bootboxtext: APP.IDLE_TIME,
      //   openmodel: true,
      // });
    }

    this.interval = setInterval(() => this.timer(windowValues), 5000);
    if (Platform.OS === 'web') {
      source = sessionStorage.getItem('source');
      machine = sessionStorage.getItem('machine');
    }
    if (machine) {
      this.setState({ machine: true })
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  timer = windowValues => {
    if (
      windowValues.hostname !== 'localhost' &&
      windowValues.hostname !== 'reacticicidev.niveussolutions.com' &&
      this.state.workingtime &&
      !(this.workingTime >= 6 && this.workingTime < 23)
    ) {
      this.setState({
        workingtime:
          windowValues.hostname !== 'localhost' &&
            windowValues.hostname !== 'reacticicidev.niveussolutions.com'
            ? true
            : true
      });
      this.interval = setInterval(() => this.timer(windowValues), 5000);
    }
  };

  navigateOptions() {
    const { history } = this.props;
    if (
      window.location.pathname ===
      `${'/' + injectUrlPaths(window.location).path + '/'}`
    ) {
      history.push(`${'/' + injectUrlPaths(window.location).path + ''}`);
    }
  }

  refresh() {
    var clear = [
      'time',
      'product_name',
      'payment_gateway',
      'stopwatch',
      'credit_opted',
      'flow',
      'easyPay',
      'token'
    ];

    clear.map(item => {
      sessionStorage.removeItem(item);
    });
  }

  handleKeyPress = event => {
    if (this.state.userIdle && event.keyCode === 9) {
      event.preventDefault();
    }
  };

  closebootbox = () => {
    if (this.state.userIdle) {
      this.refresh();
      window.removeEventListener('keydown', this.handleKeyPress);
      Linking.openURL(window.location.origin);
    } else {
      this.setState({
        openmodel: false,
        modalopenhide: false
      });
    }
  };

  onIdle = async () => {
    const pathName = window.location.pathname;
    if (pathName !== '/' 
    && pathName !== '/servicing/rekycProcess' 
    && !pathName.includes(ALL_CONSTANTS.DGOV_SERVICE_PROCESS_URL)
    && !pathName.includes(ALL_CONSTANTS.PEBBLEURL_SOLVENCY)
    && !pathName.includes(ALL_CONSTANTS.PEBBLEURL_PAYSLIP)
    && !pathName.includes(ALL_CONSTANTS.PEBBLEURL_EMAIL)
    && !pathName.includes(ALL_CONSTANTS.DUALRES_SERVICE_PROCESS_URL)
    && !pathName.includes(ALL_CONSTANTS.PEBBLEURL_DEMOG)
    && !pathName.includes(ALL_CONSTANTS.PEBBLEURL_VARIANT)
    && !pathName.includes(ALL_CONSTANTS.PEBBLEURL_BANKINGKYC)
    && !pathName.includes(ALL_CONSTANTS.DATAQUALITY_SERVICE_URL)
    && !pathName.includes(NLI_CONSTANTS.NLI_PREPAID_HOME_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_PREPAID_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_PREPAID_KYC_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_PREPAID_APPLICATION_PROCESS_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_PREPAID_EMAIL_VERIFICATION_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_PREPAID_DASHBOARD_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_DONATION_FORM_LOGIN)
    && !pathName.includes(NLI_CONSTANTS.NLI_PREVIEW_DONATION_FORM)
    && !pathName.includes(NLI_CONSTANTS.NLI_CASH_KARO_LOGIN)
    && !pathName.includes(NLI_CONSTANTS.NLI_GRID_CARD_LOGIN)
    && !pathName.includes(NLI_CONSTANTS.NLI_GRID_CARD_ACCOUNT_VALIDATION)
    && !pathName.includes(NLI_CONSTANTS.NLI_GRID_CARD_DEBITCARD_VALIDATION)
    && !pathName.includes(NLI_CONSTANTS.NLI_GRID_CARD_AUTHENTICATION)
    && !pathName.includes(NLI_CONSTANTS.NLI_LOAN_EMI_CHECK_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_ENACH_FORM)
    && !pathName.includes(NLI_CONSTANTS.NLI_VIDEO_KYC_FORM)
    && !pathName.includes(NLI_CONSTANTS.NLI_UNCLAIMED_DEPOSIT_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_UNCLAIMED_DEPOSIT_ACCOUNT_DETAIL_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_SHARE_HOLDER_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_INVESTOR_UPLOAD_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_UNCLAIMED_DIVIDENTS_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_UNCLAIMED_DIVIDENTS_LIST_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_EASY_POS_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_SUBMIT_POS_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_NSE_TICKER_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_KYC_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_TRACK_SHIPMENT_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_EMV_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_COMPLIMENTS_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_NRI_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_OFFER_PORTAL_LOGIN_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_AURA_LOGIN_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_AURA_ACCOUNT_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_AURA_SUBMIT_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_BLUEDART_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_LOAN_TRACKER_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_SUBMITTED_RESPONSE_PAGE_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_CASH_DEPOSIT_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_PROPERTY_SEARCH_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_GDPR_HOME_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_GDPR_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_GDPR_CHECK_CUSTOMER_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_CREDITCARD_EMI_CHECK_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_FEEDBACK_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_FEEDBACK_EXPERIENCE_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_FEEDBACK_NPS_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_FOREX_INSTA_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_DETAILS_RESPONSE_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_FOREX_REQ_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_SR_CONFIRMATION_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_SR_REQUEST_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_TRACK_MY_LOAN_LOGIN_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_CAR_LOAN_DASHBOARD_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_GRIEVANCE_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_SUBMIT_GRIEVANCE_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_GRIEVANCE_TWO_FORM_PATH)
    && !pathName.includes(NLI_CONSTANTS.NLI_GRIEVANCE_FORM_THREE_PATH)
    && !pathName.includes(NLI_CONSTANTS.DISCREPANT_HOME)
    && !pathName.includes(NLI_CONSTANTS.DISCREPANT_AUTH)
    && !pathName.includes(NLI_CONSTANTS.DISCREPANT_SUCCESS)
    ) {
      window.addEventListener('keydown', this.handleKeyPress);
      let sessionExiprytimer = sessionStorage.getItem('sessionExipry');
      let ExternalFlag;
      if (Platform.OS === 'web') {
        ExternalFlag = sessionStorage.getItem('ExternalFlag');
      } else {
        ExternalFlag = await AsyncStorage.getItem('ExternalFlag');
      }
      const { history } = this.props;
      let newProps = this.props.location.state;
      newProps = { ...newProps, idle: true };
      let sourceType = sessionStorage.getItem('sourceType');
      let isStandAloneURL = sessionStorage.getItem('isStandAloneURL');
      if (isStandAloneURL || sourceType == "CSP-IMOBILE") {
        return
      }
      let redirectPath = '/servicing/index.html';

      if (pathName.includes(ALL_CONSTANTS.PROFILE_PATH)) {
        redirectPath = ALL_CONSTANTS.PROFILE_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.DEPOSITS_PATH)) {
        redirectPath = ALL_CONSTANTS.DEPOSITS_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH)) {
        redirectPath = ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.FOREX_PATH)) {
        redirectPath = ALL_CONSTANTS.FOREX_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.CREDIT_CARD_PATH)) {
        redirectPath = ALL_CONSTANTS.CREDIT_CARD_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.LOAN_PATH)) {
        redirectPath = ALL_CONSTANTS.LOAN_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.ACCOUNT_PATH)) {
        redirectPath = ALL_CONSTANTS.ACCOUNT_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.DUE_PATH)) {
        redirectPath = ALL_CONSTANTS.DUE_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.ATMDEBIT_PATH)) {
        redirectPath = ALL_CONSTANTS.ATMDEBIT_PATH;
      } else if (pathName.includes(ALL_CONSTANTS.OTHERURL_PATH)) {
        redirectPath = ALL_CONSTANTS.OTHERURL_PATH;
      }
      var parts = window.location.pathname.split('/');
      var path = parts[parts.length - 1];


      if (path == 'termsConditions') {
        const pathName = window.location.pathname;
        const domainName = window.location.origin;
        const path = [
          ALL_CONSTANTS.PROFILE_PATH,
          ALL_CONSTANTS.ACCOUNT_PATH,
          ALL_CONSTANTS.CREDIT_CARD_PATH,
          ALL_CONSTANTS.LOAN_PATH,
          ALL_CONSTANTS.DEPOSITS_PATH,
          ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH,
          ALL_CONSTANTS.FOREX_PATH,
          ALL_CONSTANTS.DUE_PATH,
          ALL_CONSTANTS.ATMDEBIT_PATH,
          ALL_CONSTANTS.OTHERURL_PATH
        ];

        let updatedPath = pathName.substr(0, pathName.lastIndexOf('/'));
        if (path.includes(updatedPath)) {
          
          if (ExternalFlag != 'false') {
          } else {
            window.location.href = `${domainName}${updatedPath}`;
          }
          return;
        } else {
          if (ExternalFlag != 'false') {
          } else {
            window.location.href = `${window.location.origin}/servicing/index.html`;
          }
        }
      }
      else {
        if (ExternalFlag != 'false') {
          history.push({
            pathname: '/servicing/redirectHome',
            state: newProps
          });
        } else {
          if (machine) {
            window.location.href = `http://localhost:9309/Service1.svc`;
          } else {
            history.push({
              pathname: redirectPath,
              state: newProps
            });
          }
        }

      }
    }
  };

  setTimeout = data => {
    if (data.otptimer) {
      this.idleTimer.pause();
    } else {
      this.idleTimer.resume();
    }
  };
  clearStorage = data => {
    data.map(item => {
      sessionStorage.removeItem(item);
    });
  };

  render() {
    // * Reduces TBT by preventing rendering if location access is blocked
    // * should be a state variable
    // let isLocationAllowed = document.getElementById("location-help-modal").style.display == "none";

   

    const { measure } = this.props;
    const ua = window.navigator.userAgent;
    let values = { ...this.state, setTimer: val => this.setTimeout(val) };
    return (
      !this.state.isDuplicate ?
        <CacheBuster enableCaching>
          {({ loading, isLatestVersion, refreshCacheAndReload }) => {
            if (loading) return null;
            if (!loading && !isLatestVersion) {
              refreshCacheAndReload();
            }
            return (
              browserSupport(ua) && (
                <LinearGradient {...this.state.linearColors}>
                  <IdleTimer
                    ref={ref => {
                      this.idleTimer = ref;
                    }}
                    element={document}
                    onIdle={this.onIdle}
                    debounce={APP.DEBOUNCE}
                    timeout={APP.IDLE_TIMEOUT}
                  />
                  <View onLayout={this.handleLayout} style={styles.container}>
                      <Helmet>
                        <meta name="robots" content="noindex, follow" />
                      </Helmet>
                    <script nonce="c5pContent" >
                      window.onpopstate = function() {this.props.history.go(1)};
                    </script>

                    {/* <View style={styles.nav}>
                    <TopNav refresh={this.refresh} />
                  </View> */}
                    {this.state.workingtime ? (
                      <AppProvider value={{ ...this.myContext, ...this.state }}>
                        <View style={styles.rootStyle}>
                          <CustomBootbox
                            {...this.props}
                            measure={this.state.measure}
                            bootboxtext={this.state.bootboxtext}
                            bootboxmodal={this.state.openmodel}
                            closebootbox={this.closebootbox}
                            hideBlackout
                          />
                          <Switch>
                            {WebRoutesGenerator(
                              { routeMap },
                              this.changeBackground
                            )}
                          </Switch>
                          <ModalContainer />
                        </View>
                      </AppProvider>
                    ) : (
                      <AvailableTimeError
                        maintainanceText={this.state.maintainanceText}
                      />
                    )}
                  </View>
                </LinearGradient>
              )
            );
          }}
        </CacheBuster> : <View style={{ height: Dimensions.get("window").height, }}>
          <View
            style={[styles.messageContainer, { height: this.state.windowHeight },
            styles[getResponsiveStyle('messageContainer', measure)]
            ]}
          >
            <Text
              style={[styles.messageHeading,
              styles[getResponsiveStyle('messageHeading', measure)]
              ]}
            >
              {SESSION_ALREADY_OPEN.msg1}
            </Text>
            <Text
              style={[styles.messageSubheading,
              styles[getResponsiveStyle('messageSubheading', measure)]
              ]}
            >
              <br></br>
              {SESSION_ALREADY_OPEN.msg2}
            </Text>
          </View>
        </View>

    );
  }
}

export default withRouter(App);
